// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const BrightnessOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M19.24 9V4.77h-4.25l-2.99-3-3 3H4.77v4.25L1.77 12l3 3v4.24H9l2.99 3 3-3h4.24v-4.25l3-2.99-3-3zm-1.81 5.24v3.19h-3.19L12 19.67l-2.24-2.24H6.57v-3.19L4.33 12l2.24-2.24V6.57h3.19L12 4.33l2.24 2.24h3.19v3.19L19.67 12l-2.24 2.24zM12 7.02v9.96a4.98 4.98 0 000-9.96z","fill":"currentColor"}}]},"name":"brightness","theme":"outlined"};

const BrightnessOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={BrightnessOutlinedSvg} />;
  BrightnessOutlined.displayName = 'BrightnessOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(BrightnessOutlined);
